import { classes, cleanString } from 'shared';

export function YesOrNo({
  value,
  onUpdate,
  name,
  description,
  className,
  children,
  error,
}: {
  value: boolean;
  onUpdate: (v: boolean) => void;
  name: string;
  description?: string;
  className?: string;
  children?: React.ReactNode;
  error?: string | string[];
}) {
  return (
    <div className={classes(className)} id={cleanString(name + '-bool')}>
      <label className="flex flex-wrap text-base font-medium text-gray-900">
        {name}
        {children}
      </label>
      <p className="mb-4 text-sm leading-5 text-gray-500 empty:hidden">{description}</p>
      <fieldset className="mt-2">
        <legend className="sr-only">{name}</legend>
        <div className="flex items-center justify-start space-x-4 px-4">
          <div className="flex items-center">
            <input
              id={cleanString(name + '-yes')}
              name={cleanString(name + '-yes')}
              type="radio"
              value="yes"
              checked={value === true}
              className="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-500"
              onChange={() => onUpdate(true)}
            />
            <label htmlFor={cleanString(name + '-yes')} className="ml-3 block text-sm font-medium text-gray-700">
              Yes
            </label>
          </div>
          <div className="flex items-center">
            <input
              id={cleanString(name + '-no')}
              name={cleanString(name + '-no')}
              type="radio"
              value="no"
              checked={value === false}
              className="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-500"
              onChange={() => onUpdate(false)}
            />
            <label htmlFor={cleanString(name + '-no')} className="ml-3 block text-sm font-medium text-gray-700">
              No
            </label>
          </div>
        </div>
      </fieldset>
      <span id={`${cleanString(name)}-error`} className="text-sm text-red-600 empty:hidden">
        {typeof error !== 'string' && error?.length ? error?.[0] : error}
      </span>
    </div>
  );
}
